import React, { useEffect, useState } from 'react';
import '../../../Components/style/admin.css'
import { PiMagicWand} from 'react-icons/pi';
import { FiChevronRight, FiFilePlus} from 'react-icons/fi';
import { firebase } from '../../../base';
import MetaTags from '../../../Components/meta';
import { useNavigate } from 'react-router-dom';

const StatisticCard = ({ title, value, icon, onClick }) => {
    return (
        <div className='bg-white rounded-lg shadow-md'>
            <div className='flex items-start justify-between p-4'>
                <div className='flex flex-col gap-2'>
                    <p className='text-ss text-gray-500'>{title}</p>
                    <p className='text-sts text-gray-700'>{value}</p>
                </div>
                <div className='bg-gray-200 flex items-center justify-center rounded-md p-2'>
                    {icon}
                </div>
            </div>
            <hr className='w-full bg-gray-200' />
            <div className='flex items-start justify-between px-4 py-3 cursor-pointer' onClick={onClick}>
                <p className='text-ss text-gray-500'>View reports</p>
                <FiChevronRight size={20} className='text-gray-400' />
            </div>
        </div>
    )
}

export default function Dashboard() {
    const navigate = useNavigate();
    const opts = {
        height: '100%',
        width: '100%',
        playerVars: {
            autoplay: 0,
        },
    };
    const [data, setData] = useState({applications: 0});

    useEffect(() => {
        const unsubscribe = firebase.firestore().collection('submissoes').where('status', '==', 'pending').onSnapshot(snapshot => {
            setData({applications: snapshot.docs.length});
        });
        return () => {
            unsubscribe();
        }
    }, []);

    const goApplications = () => {
        navigate('/admin/applications');
    }


    return (
        <>
            <MetaTags
                title='Dashboard | Institute Nilia'
                description='Dashboard for Institute Nilia'
                image={require('../../../assets/icons/nilia.webp')}
                name='Institute Nilia'
            />
            <div className="admin-page">
                <div className='admin-banner'>
                    <p className='text-banner'>Good Night, {firebase.auth()?.currentUser?.displayName || 'User'}!</p>
                    <div className='banner-ai mt-6'>
                        <PiMagicWand size={25} className='text-gray-400' />
                        <hr className='mx-1 h-4 w-[1px] shrink-0 bg-gray-300' />
                        <p className='text-ss text-gray-400'>Chat with AI about your business.</p>
                    </div>
                </div>
                <div className='mt-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3'>
                    <StatisticCard title='New Applications' value={data.applications} icon={<FiFilePlus size={20} color='#1d095e' />} onClick={goApplications} />
                </div>
                
            </div>
        </>
    )

}